import * as React from "react";

type AnyRef<T> = React.RefObject<T | null>;

export default function useOnClickOutside<T extends HTMLElement>(
  ref: AnyRef<T>,
) {
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    if (!open) return;

    function onDocMouseDown(e: MouseEvent) {
      const target = e.target as Node | null;
      if (!target) return;
      if (ref.current?.contains(target)) return;
      setOpen(false);
    }

    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, [open, ref]);

  return { open, setOpen };
}
